import React from 'react';
import PropTypes from 'prop-types';
import ProgressBox from './ProgressBox';
import './styles.scss';

const AnsweredToggle = ({
    currentQuestionIdx, totalQuestions
}) => {
    return (
        <div className='answered-toggle-container'>
            <ProgressBox currentQuestionIdx={ currentQuestionIdx } totalQuestions={ totalQuestions } />
        </div>
    );
};

AnsweredToggle.propTypes = {
    currentQuestionIdx: PropTypes.number,
    totalQuestions: PropTypes.number
};

AnsweredToggle.defaultProps = {
    currentQuestionIdx: 0,
    totalQuestions: 0
};

export default AnsweredToggle;
